module.exports = __webpack_public_path__ + "static/media/03PerformancePhotos.1a3c01c6.jpeg";